//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

/**
 * Formats the given text into a tracking ID format by replacing all spaces
 * with hyphens and converting the text to lowercase. This formatted
 * tracking ID can be appended to an existing tracking ID.
 *
 * @param {string} text - The input text to format.
 * @returns {string} The formatted tracking ID.
 */
export const formatTrackingId = (text: string) =>
  text.replace(/\s+/g, '-').toLowerCase();
